import angular from 'angular';
import { IFiltroEventoEscala } from '../../models/escala.filtros.model';

export class MeurhEscalaConfigVisualizacaoModalService {
  static $inject = ['$uibModal'];

  constructor(public $uibModal: ng.ui.bootstrap.IModalService) {
  }

  open(entity: IFiltroEventoEscala) {
    return this.$uibModal.open({
      template: require('html-loader!./config-visualizacao.modal.html'),
      controller: 'MeurhEscalaConfigVisualizacaoModalController',
      controllerAs: 'mrh_scl_vslzc_mdl_cntrllr',
      windowClass: 'nsj-modal-lg-no-height',
      resolve: {
        entity: () =>  angular.copy(entity)
      }
    });
  }
}
